export default "__VITE_ASSET__6RRR0EU7__ 480w, __VITE_ASSET__ClazV4CY__ 720w, __VITE_ASSET__JaiaeLgK__ 1080w";